/**
 * Origin protiv kojeg se razrjesavaju relativne API putanje.
 *
 * U browseru je to origin same stranice. Na serveru (SSR prefetch) mora biti
 * loopback: relativan fetch pod Bunom baca "fetch() URL is invalid", a
 * publicOrigin() bi znacio da lokalni SSR tiho povlaci produkcijske podatke.
 */
export function apiBase(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  // typeof-guarded: this branch is unreachable in a browser bundle, but
  // `process` is not shimmed there, so a naive `process.env.PORT` would
  // throw "process is not defined" if the window guard above were ever
  // loosened or removed.
  const port = typeof process !== "undefined" ? process.env.PORT : undefined;
  return `http://127.0.0.1:${port || 3000}`;
}

/** Apsolutni URL za API putanju, ispravan i u browseru i na serveru. */
export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return new URL(path, apiBase()).toString();
}
